export enum ConsentFormPageTestId {
    CountryField = 'ConsentFormPageTestId.CountryField',
    DateField = 'ConsentFormPageTestId.DateField',
}

export enum PasswordFormPageTestId {
    PasswordField = 'PasswordFormPageTestId.PasswordField',
    BackButton = 'PasswordFormPageTestId.BackButton',
    ContinueButton = 'PasswordFormPageTestId.SubmitButton',
    LengthValidation = 'PasswordFormPageTestId.LengthValidation',
    SpecialCharacterValidation = 'PasswordFormPageTestId.SpecialCharacterValidation',
    NumberValidation = 'PasswordFormPageTestId.NumberValidation',
    UppercaseValidation = 'PasswordFormPageTestId.UppercaseValidation',
    LowercaseValidation = 'PasswordFormPageTestId.LowercaseValidation',
}

export enum RegistrationPageTestId {
    LanguagePreferenceSelect = 'RegistrationPageTestId.LanguagePreferenceSelect',
}

export enum NonExistentLinkTestId {
    InvalidLinkDescription = 'NonExistentLinkTestId.InvalidLinkDescription',
}
